import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { createHashStateHook } from "../../../stores/useHashState";
import { Button } from "../../../ui/Button/Button";
import { ArrowLeftIcon } from "../../../ui/icons/ArrowLeftIcon";
import { LeadFormCompare } from "../../LeadForm/LeadFormCompare";
import { useTireCompareIds } from "./useTireCompareIds";

export const compareTiresHash = "#compare-tires";
export const useCompareHash = createHashStateHook(compareTiresHash);

type HeaderProps = {
  compareIds: string[];
};

export const Header: FunctionComponent<HeaderProps> = ({ compareIds }) => {
  const { t } = useTranslation();
  const [, { hide }] = useCompareHash();
  const [selectedIds] = useTireCompareIds();
  return (
    <>
      <Button aria-label="backToSearchResults" className="-ml-4" onClick={hide}>
        <ArrowLeftIcon /> {t("searchResults.backToResults")}
      </Button>
      <header className="flex gap-1 mb-4 md:mb-8">
        <h2 className="text-lg font-semibold md:text-2xl lg:text-3xl mr-auto">
          {t(selectedIds.length ? "compare.selected" : "compare.quick")}
        </h2>
        <LeadFormCompare compareIds={compareIds} />
      </header>
    </>
  );
};
